import { FaListUl, FaUpload, FaVideo } from "react-icons/fa";
import { FaBoxesPacking } from "react-icons/fa6";
import {
  PiArticleNyTimesFill,
  PiCarBold,
  PiChartBarBold,
  PiCityBold,
  PiExportBold,
  PiGiftBold,
  PiMoneyWavyBold,
  PiShoppingCartBold,
  PiSlidersBold,
  PiWalletBold,
  PiMessengerLogo,
  PiHandshakeBold,
  PiBackpack,
  PiClockCounterClockwiseBold,
  PiQuestionBold,
  PiFileTextBold,
  PiChatCircleBold,
  PiUsersBold,
  PiEnvelopeSimpleBold,
  PiChatsCircleBold,
} from "react-icons/pi";

export const sidebarData = [
  {
    name: "کاربران",
    icon: (
      <svg
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        stroke="currentColor"
        className="h-6 w-6"
      >
        <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
      </svg>
    ),
    link: "",
    children: [
      {
        name: "افزودن کاربر",
        link: "/add-user",
      },
      {
        name: "لیست کاربران",
        link: "/user-list",
      },
    ],
  },
  {
    name: "دسته بندی",
    icon: <FaListUl size={22} />,
    link: "",
    children: [
      {
        name: "افزودن دسته بندی",
        link: "/add-category",
      },
      {
        name: "لیست دسته بندی ها",
        link: "/category-list",
      },
    ],
  },
  {
    name: "دسته بندی آموزش‌ها",
    icon: <FaListUl size={22} />,
    link: "",
    children: [
      {
        name: "افزودن دسته بندی آموزش‌ها",
        link: "/add-learn-category",
      },
      {
        name: "لیست دسته بندی آموزش‌ها",
        link: "/learn-category-list",
      },
    ],
  },
  {
    name: "پیامک",
    icon: <PiMessengerLogo size={22} />,
    link: "",
    children: [
      {
        name: "افزودن کانفیگ جدید",
        link: "/add-sms",
      },
      {
        name: "لیست کانفیگ ها",
        link: "/sms-list",
      },
    ],
  },
  {
    name: "آموزش‌ها",
    icon: <FaVideo size={22} />,
    link: "",
    children: [
      {
        name: "افزودن آموزش",
        link: "/add-learn",
      },
      {
        name: "لیست آموزش‌ها",
        link: "/learn-list",
      },
    ],
  },
  {
    name: "محصولات",
    icon: <FaBoxesPacking size={22} />,
    link: "",
    children: [
      {
        name: "افزودن محصول",
        link: "/add-product",
      },
      {
        name: "لیست محصولات",
        link: "/product-list",
      },
    ],
  },
  {
    name: "موجودی محصولات",
    icon: <FaBoxesPacking size={22} />,
    link: "",
    children: [
      {
        name: "لیست محصولات",
        link: "/product-stocks-lis",
      },
    ],
  },
  {
    name: "سفارشات عطارباشی",
    icon: <PiShoppingCartBold size={22} />,
    link: "",
    children: [
      {
        name: "مدیریت سفارشات عطارباشی",
        link: "/order-list",
      },
      {
        name: "آپلود بارکد عطارباشی",
        link: "/barcodes-upload",
      },
    ],
  },
  {
    name: "سفارشات صبورا",
    icon: <PiShoppingCartBold size={22} />,
    link: "",
    children: [
      {
        name: "مدیریت سفارشات صبورا",
        link: "/sabora-order-list",
      },
      {
        name: "آپلود بارکد صبورا",
        link: "/sabora-barcodes-upload",
      },
    ],
  },
  {
    name: "حمل و نقل",
    icon: <PiCarBold size={22} />,
    link: "",
    children: [
      {
        name: "افزودن حمل و نقل",
        link: "/add-product-shipping",
      },
      {
        name: "لیست حمل و نقل‌ها",
        link: "/product-shipping-list",
      },
    ],
  },
  {
    name: "تخفیفات",
    icon: <PiMoneyWavyBold size={22} />,
    link: "",
    children: [
      {
        name: "مدیریت تخفیف",
        link: "/discount-manage",
      },
    ],
  },
  {
    name: "هدیه سفارشات",
    icon: <PiGiftBold size={22} />,
    link: "",
    children: [
      {
        name: "لیست هدایا",
        link: "/gift-order-product-list",
      },
      {
        name: "ثبت هدیه",
        link: "/gift-order-product-form",
      },
    ],
  },
  {
    name: "کوپن‌ها",
    icon: <PiMoneyWavyBold size={22} />,
    link: "",
    children: [
      {
        name: "افزودن کوپن",
        link: "/add-coupon",
      },
      {
        name: "لیست کوپن‌ها",
        link: "/coupon-list",
      },
    ],
  },
  {
    name: "کیف پول",
    icon: <PiWalletBold size={22} />,
    link: "",
    children: [
      {
        name: "ایجاد تراکنش",
        link: "/add-deposit",
      },
      {
        name: "لیست تراکنش‌ها",
        link: "/wallets-transaction",
      },
    ],
  },
  {
    name: "مقالات",
    icon: <PiArticleNyTimesFill size={22} />,
    link: "",
    children: [
      { name: "افزودن مقاله", link: "/add-article" },
      { name: "لیست مقاله ها", link: "/article-list" },
    ],
    subMenuToggle: "subMenu6",
  },
  {
    name: "اسلایدر",
    icon: <PiSlidersBold size={22} />,
    link: "",
    children: [
      { name: "افزودن اسلایدر", link: "/add-slider" },
      { name: "لیست اسلایدر ها", link: "/slider-list" },
    ],
    subMenuToggle: "subMenu16",
  },
  {
    name: " فیلد پابلیک",
    icon: <PiSlidersBold size={22} />,
    link: "",
    children: [{ name: "مدیریت فیلد ها", link: "/public-field-manage" }],
    subMenuToggle: "subMenu36",
  },
  {
    name: "استان و شهر",
    icon: <PiCityBold size={22} />,
    link: "",
    children: [{ name: "مدیریت استان و شهر", link: "/province-list" }],
    subMenuToggle: "subMenu17",
  },
  {
    name: "بک اپ",
    icon: <PiBackpack size={22} />,
    link: "",
    children: [{ name: "مدیریت بک اپ", link: "/backup-list" }],
    subMenuToggle: "subMenu30",
  },
  {
    name: "فایل ها",
    icon: <FaUpload size={22} />,
    link: "",
    children: [
      { name: "آپلود فایل", link: "/file" },
      { name: "لیست فایل ها", link: "/file-list" },
    ],
    subMenuToggle: "subMenu5",
  },
  {
    name: "گزارشات",
    icon: <PiChartBarBold size={22} />,
    link: "",
    children: [
      { name: "محصولات", link: "/reports/products" },
      { name: "سفارشات", link: "/reports/orders" },
      { name: "تمام سفارشات", link: "/reports/all-orders" },
      { name: "کاربران", link: "/reports/users" },
      { name: "گزارش فروش ماهانه", link: "/reports/usersMounthly" },
      { name: "خرید اولی ها", link: "/reports/users-first-sales" },
      { name: "تعداد مشتریان کاربران", link: "/reports/users-customer-counts" },
      { name: "لیست مشتریان کاربران", link: "/reports/users-customers-list" },
      {
        name: "مشتریان غیرفعال مشاوران",
        link: "/reports/inactive-users-customers",
      },
      {
        name: "لیست فروش کاربران تایپ 2",
        link: "/reports/orders-unique-mobile-sales",
      },
      { name: "لیست کمیسیون ها", link: "/reports/all-users-commisions" },
      { name: "مشتریان شبکه اجتماعی", link: "/reports/social-media-customer" },
    ],
    subMenuToggle: "subMenu7",
  },
  {
    name: "نظرات و دیدگاه‌ها",
    icon: <PiChatCircleBold size={22} />,
    link: "",
    children: [
      { name: "مدیریت نظرات", link: "/reviews-list" },
    ],
    subMenuToggle: "subMenu60",
  },
  {
    name: "سوالات متداول",
    icon: <PiQuestionBold size={22} />,
    link: "",
    children: [
      { name: "افزودن سوال", link: "/add-faq" },
      { name: "لیست سوالات", link: "/faq-list" },
    ],
    subMenuToggle: "subMenu5",
  },
  {
    name: "قوانین و مقررات",
    icon: <PiFileTextBold size={22} />,
    link: "",
    children: [
      { name: "افزودن قانون", link: "/add-terms" },
      { name: "لیست قوانین", link: "/terms-list" },
    ],
    subMenuToggle: "subMenu50",
  },
  {
    name: "تیم ما",
    icon: <PiUsersBold size={22} />,
    link: "",
    children: [
      { name: "افزودن عضو", link: "/add-team-member" },
      { name: "لیست اعضای تیم", link: "/team-member-list" },
      { name: "تصاویر صفحه درباره ما", link: "/about-settings" },
    ],
    subMenuToggle: "subMenu55",
  },
  {
    name: "خروجی دیتا",
    icon: <PiExportBold size={22} />,
    link: "",
    children: [{ name: "خروجی دیتا", link: "/export" }],
    subMenuToggle: "subMenu5",
  },
  {
    name: "فعالیت‌های ادمین",
    icon: <PiClockCounterClockwiseBold size={22} />,
    link: "",
    children: [{ name: "لیست فعالیت‌ها", link: "/admin-activities" }],
    subMenuToggle: "subMenu40",
  },
  {
    name: "نمایندگی",
    icon: <PiHandshakeBold size={22} />,
    link: "",
    children: [
      { name: "درخواست‌های نمایندگی", link: "/affiliate-request-list" },
      { name: "سوالات متداول نمایندگی", link: "/affiliate-faq-list" },
      { name: "مزایای نمایندگی", link: "/affiliate-benefit-list" },
      { name: "خدمات نمایندگی", link: "/affiliate-service-list" },
      { name: "تنظیمات نمایندگی", link: "/affiliate-settings" },
      { name: "نظرات نمایندگان", link: "/affiliate-testimonial-list" },
    ],
    subMenuToggle: "subMenu60",
  },
  {
    name: "تجربه مشتریان",
    icon: <PiChatsCircleBold size={22} />,
    link: "",
    children: [
      { name: "بررسی تجربه‌ها", link: "/customer-experience-list" },
    ],
    subMenuToggle: "subMenu62",
  },
  {
    name: "تماس با ما",
    icon: <PiEnvelopeSimpleBold size={22} />,
    link: "",
    children: [{ name: "پیام‌های کاربران", link: "/contact-message-list" }],
    subMenuToggle: "subMenu61",
  },
];
export const manufacturerSidBar  = sidebarData.filter(item=>item.name === "سفارشات عطارباشی" || item.name === "سفارشات صبورا")
